var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FF7979",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 11,
    y: 6,
    width: 2,
    height: 9,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    x: 11,
    y: 17,
    width: 2,
    height: 2,
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.330150d455903f3943e815b9c6ab8a3d.svg";
export { ForwardRef as ReactComponent };